export default __webpack_public_path__ + "static/media/desktop-blue.081ebfaa.jpeg";